var map = {
	"./Academy-of-Art-University_Logo.jpg": 212,
	"./Aechelon.png": 750,
	"./Google.jpg": 948,
	"./Loyalize.png": 462,
	"./Lucasarts.png": 939,
	"./Oculus.png": 760,
	"./Syracuse University.png": 160,
	"./The Orphanage.png": 751,
	"./TownsendDavidResume_2O24.pdf": 170,
	"./Viggle.jpeg": 18,
	"./dt01.jpg": 120,
	"./fb.png": 525,
	"./magic leap.png": 128
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 617;